export default __webpack_public_path__ + "static/Seeing-Near-ac834254229f71b3884bb83b218a7af7.png";